import {
  WarehouseAction,
  WarehouseTypes,
  WarehouseState,
} from '../../types/warehouse';

const initialState: WarehouseState = {
  byZones: [],
  noVolume: [],
  forecast: [],
  forecastCoef: null,
  loading: true,
  loadingForecast: true,
};

export const warehouseReducer = (
  state = initialState,
  action: WarehouseAction
): WarehouseState => {
  switch (action.type) {
    case WarehouseTypes.GET_WAREHOUSE_DATA:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    case WarehouseTypes.GET_WAREHOUSE_FORECAST:
      return {
        ...state,
        forecast: action.payload,
        loadingForecast: false,
      };
    case WarehouseTypes.SET_WAREHOUSE_FORECAST:
      return {
        ...state,
        forecastCoef: action.payload,
      };
    case WarehouseTypes.SET_WAREHOUSE_LOADING:
      return {
        ...state,
        loading: true,
      };
    case WarehouseTypes.CLEAR_WAREHOUSE:
      return initialState;
    default:
      return state;
  }
};
